export default __webpack_public_path__ + "static/media/file-upload-solid.b9568990.svg";